module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/88.3e333d5e.png";